import React, { useEffect,useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation,Navigate } from 'react-router-dom';
import { UserProvider,UserContext } from './contexts/UserContext';
import ProtectedRoute from './components/protectedRoute';

import ListarPacientes from './components/ListarPacientes';
import ListarEvaluaciones from './components/ListarEvaluaciones';
import CrearEvaluacion from './components/CrearEvaluacion';
import EditarEvaluacion from './components/EditarEvaluacion';
import Perfil from './components/Perfil';
import NavBar from './components/NavBar';
import EditarPaciente from './components/EditPatient';
import CrearPaciente from './components/CrearPaciente';
import Login from './components/Login';
import LogoutButton from './components/LogoutButton';
import AdminPanel from './components/AdminPanel';
import Empresas from './components/Empresas';
import CrearEmpresa from './components/CrearEmpresa';
import EditarEmpresa from './components/EditarEmpresa';
import GestionarBaterias from './components/GestionarBaterias';
import ChangePassword from './components/ChangePassword';
import CrearUsuario from './components/CrearUsuario';
import DetallesPerfil from './components/DetallesPerfil';
import DetalleEmpresa from './components/DetallesEmpresa';
import CrearContactoEmpresa from './components/CrearContacto';
import EditarContacto from './components/EditarContacto';
import PanelExamenes from './components/PanelExamenes';
import CrearExamen from './components/CrearExamen';
import EditarExamen from './components/EditarExamen';
import RevisarEvaluacion from './components/RevisarEva';
import EmpresaDashboard from './components/EmpresaDashboard';
import PacienteDashboard from './components/PacienteDashboard';
import VerificarFicha from './components/VerificarFicha';
import ConfirmModal from './components/ConfirmModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PerfilResolver = () => {
  const { currentUser } = useContext(UserContext);
  if (currentUser?.tipo === 'empresa') {
    return <EmpresaDashboard />;
  }
  if (currentUser?.tipo === 'paciente') {
    return <PacienteDashboard />;
  }
  return <Perfil />;
};


// Prefijo de ruta -> nombre de seccion mostrado en la pestaña del navegador (ej. "Evaluaciones / Xios").
const SECCIONES_TITULO = [
  { prefix: '/admin', nombre: 'Admin' },
  { prefix: '/pacientes', nombre: 'Pacientes' },
  { prefix: '/evaluaciones', nombre: 'Evaluaciones' },
  { prefix: '/empresas', nombre: 'Empresas' },
  { prefix: '/baterias', nombre: 'Baterías' },
  { prefix: '/verificar', nombre: 'Verificar Ficha' },
  { prefix: '/perfil', nombre: 'Perfil' },
];

function getTituloPagina(pathname, tipoUsuario) {
  if (pathname === '/perfil' && (tipoUsuario === 'empresa' || tipoUsuario === 'paciente')) {
    return 'Dashboard / Xios';
  }
  const seccion = SECCIONES_TITULO.find((s) => pathname.startsWith(s.prefix));
  return seccion ? `${seccion.nombre} / Xios` : 'Xios';
}

function AppWrapper() {
  const location = useLocation();
  const { currentUser } = useContext(UserContext);
  const shouldShowNavBar = !['/', '/login'].includes(location.pathname) && !location.pathname.startsWith('/verificar/');
  const isLoginPage = location.pathname === '/login';

  useEffect(() => {
    if (isLoginPage) {
      document.body.classList.add('login-bg');
    } else {
      document.body.classList.remove('login-bg');
    }
  }, [isLoginPage]);

  useEffect(() => {
    document.title = getTituloPagina(location.pathname, currentUser?.tipo);
  }, [location.pathname, currentUser?.tipo]);

  return (
    <>
      {shouldShowNavBar && <NavBar />}
      <Routes>

        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<LogoutButton />} />
        <Route path="/verificar/:valor" element={<VerificarFicha />} />

        <Route 
          path="/perfil" 
          element={
            <ProtectedRoute>
              <PerfilResolver />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/perfil/detalles" 
          element={<ProtectedRoute><DetallesPerfil/></ProtectedRoute>} 
        />
        <Route 
          path="/perfil/detalles/password" 
          element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} 
        />
        <Route 
          path="/pacientes" 
          element={<ProtectedRoute allowedTypes={['usuario']}><ListarPacientes /></ProtectedRoute>} 
        />
        <Route 
          path="/pacientes/crear" 
          element={<ProtectedRoute allowedTypes={['usuario']}><CrearPaciente /></ProtectedRoute>} 
        />
        <Route 
          path="/pacientes/editar/:pacienteId" 
          element={<ProtectedRoute allowedTypes={['usuario']}><EditarPaciente /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones" 
          element={<ProtectedRoute allowedTypes={['usuario']}><ListarEvaluaciones /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones/crear/:pacienteId" 
          element={<ProtectedRoute allowedTypes={['usuario']}><CrearEvaluacion /></ProtectedRoute>} 
        /> 
        <Route 
          path="/evaluaciones/editar/:evaluacionId" 
          element={<ProtectedRoute allowedTypes={['usuario']}><EditarEvaluacion /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones/:evaluacionId/examenes" 
          element={<ProtectedRoute allowedTypes={['usuario']}><PanelExamenes /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones/:evaluacionId/examenes/crear/:tipo" 
          element={<ProtectedRoute allowedTypes={['usuario']}><CrearExamen /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones/:evaluacionId/examenes/editar/:id_examen" 
          element={<ProtectedRoute allowedTypes={['usuario']}><EditarExamen /></ProtectedRoute>} 
        />
        <Route 
          path="/evaluaciones/:evaluacionId/revisar" 
          element={<ProtectedRoute allowedTypes={['usuario']}><RevisarEvaluacion/></ProtectedRoute>} 
        />
        <Route 
          path="/empresas" 
          element={<ProtectedRoute allowedTypes={['usuario']}><Empresas /></ProtectedRoute>} 
        />
        <Route 
          path="/empresas/:empresaId" 
          element={<ProtectedRoute allowedTypes={['usuario']}><DetalleEmpresa /></ProtectedRoute>} 
        />
        <Route 
          path="/baterias" 
          element={<ProtectedRoute allowedTypes={['usuario']}><GestionarBaterias /></ProtectedRoute>} 
        />
        <Route 
          path="/admin" 
          element={<ProtectedRoute allowedPermisos={['admin']}><AdminPanel /></ProtectedRoute>} 
        />
        <Route 
          path="/admin/usuarios/crear" 
          element={<ProtectedRoute allowedPermisos={['admin']}><CrearUsuario/></ProtectedRoute>} 
        />
        <Route 
          path="/empresas/crear" 
          element={<ProtectedRoute allowedPermisos={['admin']}><CrearEmpresa /></ProtectedRoute>} 
        />
        <Route 
          path="/empresas/editar/:empresaId" 
          element={<ProtectedRoute allowedPermisos={['admin']}><EditarEmpresa /></ProtectedRoute>} 
        />
        <Route
          path="/empresas/:empresaId/contactos/crear"
          element={<ProtectedRoute allowedPermisos={['admin']}><CrearContactoEmpresa /></ProtectedRoute>}
        />
        <Route
          path="/empresas/:empresaId/contactos/editar/:contactoId"
          element={<ProtectedRoute allowedPermisos={['admin']}><EditarContacto /></ProtectedRoute>}
        />
        <Route path="*" element={<Navigate to="/perfil" replace />} />
      </Routes>
      <ToastContainer position="top-center" autoClose={4000} />
      <ConfirmModal />
    </>
  );
}

function App() {
  return (
    <UserProvider> 
      <Router>
        <AppWrapper />
      </Router>
    </UserProvider>
  );
}

export default App;
